module.exports = __webpack_public_path__ + "img/flood.9fabfd0d.svg";